import React, { useState, useEffect, useContext } from "react";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import "./ServiceAreas.css";
import HighLevelDesign from "./HighLevelDesign";
import DetailedDesign from "./DetailedDesign";
import ProcessStepper from "./ProcessStepper";
import ROW from "./ROW";
import PreConstruction from "./PreConstruction";
import Construction from "./Construction";
import MenuIcon from "@mui/icons-material/Menu";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import ProjectContext from "../../context/project/ProjectContext";
import AlertContext from "../../context/alert/AlertContext";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import {
  Grid,
  Box,
  Button,
  FormControl,
  Menu,
  MenuItem,
  InputLabel,
  NativeSelect,
} from "@mui/material";
import WorkPhase from "./WorkPhase";
import WorkflowPhase from "../../types/WorkflowPhase";
import { ProcessStep } from "../../types/ProcessStep";
import WorkflowPhases from "../../data/workflowphases.json";
import HLDesignSteps from "../../data/highlevel-design-steps.json";
import DetailDesignSteps from "../../data/detailed-design-steps.json";
import PreConstructionSteps from "../../data/preconstruction.json";
import ConstructionSteps from "../../data/construction.json";
import PermittingROWSteps from "../../data/permitting-row.json";
import ProjectCloseoutSteps from "../../data/project-closeout.json";
import { ProjectServiceArea, ServiceArea, Workflow } from "../../types/project";
import _ from "lodash";

function ServiceAreas() {
  const projectContext = useContext(ProjectContext);
  const alertContext = useContext(AlertContext);
  const {
    selectedProject,
    serviceAreas: gServiceAreas,
    getServiceAreasV2,
    updateServiceAreaStatusV2,
    getWorkflowStatusV2,
    updateWorkflowStatusV2,
  } = projectContext;
  const { showConfirmation, clearAlert } = alertContext;
  const [toggleState, setToggleState] = useState(false);
  const [serviceArea, setServiceArea] = useState("");
  const [serviceAreas, setServiceAreas] = useState<ServiceArea[]>([]);
  const [workflow, setWorkflow] = useState<Workflow[]>([]);

  const pages = [
    "High-Level Design",
    "Detailed Design",
    "ROW",
    "Pre-Construction",
    "Construction",
  ];
  const [value, setValue] = React.useState("0");
  const [activeStep, setActiveStep] = React.useState(0);
  const [currentPhase, setCurrentPhase] = React.useState("");
  // const [tabName, setTabName] = React.useState(pages[0]);
  const [phases, setPhases] = React.useState<WorkflowPhase[]>(WorkflowPhases);
  const [updatedWorkflow, setUpdatedWorkflow] = React.useState<Workflow>();
  const [updatedAction, setUpdatedAction] = React.useState<"ADD" | "UPDATE">();
  const [currentServiceArea, setCurrentServiceArea] =
    React.useState<ServiceArea>();
  const [processAction, setProcessAction] = React.useState<
    "UPDATE_WORKFLOW" | "UPDATE_SERVICE_AREA" | undefined
  >();

  useEffect(() => {
    console.log("phases-0", WorkflowPhases);
    console.log("phases", phases);
    fetchProjectServiceAreas();
    const HLDesign = phases.find(
      (element) => element.Name === "High-Level Design"
    );
    if (HLDesign) HLDesign.ProcessSteps = HLDesignSteps;
    const DetailDesign = phases.find(
      (element) => element.Name === "Detailed Design"
    );
    if (DetailDesign) DetailDesign.ProcessSteps = DetailDesignSteps;
    const PermittingROW = phases.find(
      (element) => element.Name === "Permitting & ROW"
    );
    if (PermittingROW) PermittingROW.ProcessSteps = PermittingROWSteps;
    const PreConstruction = phases.find(
      (element) => element.Name === "PreConstruction"
    );
    if (PreConstruction) PreConstruction.ProcessSteps = PreConstructionSteps;
    const Construction = phases.find(
      (element) => element.Name === "Construction"
    );
    if (Construction) Construction.ProcessSteps = ConstructionSteps;
    const ProjectCloseout = phases.find(
      (element) => element.Name === "Project Close Out"
    );
    if (ProjectCloseout) ProjectCloseout.ProcessSteps = ProjectCloseoutSteps;
    console.log("updated phases", phases);
    //eslint-disable-next-line
  }, []);

  // useEffect(() => {
  // setToggleState(() => false);
  // const _currServiceArea = serviceAreas.find(
  //   (item) => item.Name === serviceArea
  // );
  // if (_currServiceArea) {
  //   console.log("Curr Service Area", _currServiceArea);
  //   if (_currServiceArea.Status) {
  //     console.log("Curr Service Area status", _currServiceArea.Status);
  //     console.log("Workflow", phases);
  //     const _wfSteps = phases.find((item) => {
  //       if (item && item.ProcessSteps) {
  //         return (
  //           item.ProcessSteps?.findIndex(
  //             (step) => step.Name === _currServiceArea.Status
  //           ) >= 0
  //         );
  //       }
  //       return -1;
  //     });
  //     console.log("Workflow PHASE", _wfSteps);
  //     let _wfStep;
  //     if (_wfSteps && _wfSteps.ProcessSteps) {
  //       _wfStep = _wfSteps.ProcessSteps.find(
  //         (item) => item.Name === _currServiceArea.Status
  //       );
  //       console.log("Workflow STEP", _wfStep);
  //       console.log("Workflow PHHASE order", _wfSteps.PhaseOrder);
  //       console.log("Workflow Step order", _wfStep?.StepOrder);
  //       if (_wfStep && _wfSteps.PhaseOrder) {
  //         console.log("Workflow PHASE order2", _wfSteps.PhaseOrder);
  //         console.log("Workflow Step order2", _wfStep?.StepOrder);
  //         const _phase = _wfSteps.PhaseOrder ? _wfSteps.PhaseOrder - 1 : 0;
  //         setCurrentPhase(() => _phase);
  //         setValue(() => _phase + "");
  //         setActiveStep(() => _wfStep.StepOrder);
  //       }
  //     }
  //   } else {
  //     setValue(() => "0");
  //     setCurrentPhase(0);
  //     setActiveStep(0);
  //   }
  //   setToggleState(() => true);
  // }
  //eslint-disable-next-line
  // }, [serviceArea, serviceAreas]);
  const showWorkflowStep = () => {
    if (workflow) {
      const _phase = phases.filter(
        (phase) => phase.PhaseOrder === parseInt(value) + 1
      )[0];
      const _curStep = workflow.filter((item) => item.Phase === _phase.Name)[0];
      if (_curStep && _curStep.Step) {
        console.log("Current step:", _curStep.Step);
        const _curStepNo = getStepNumberForPhase(
          _curStep.Step,
          _curStep.Status ? _curStep.Status : "In-Progress"
        );
        console.log("Current step#:", _curStepNo);
        setActiveStep(_curStepNo - 1);
      } else {
        setActiveStep(0);
      }

      // workflow.filter(item=>)
      console.log("Current Phase:", _phase.Name);
      setCurrentPhase(_phase.Name);
    }
  };

  useEffect(() => {
    clearAlert && clearAlert();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    console.log("Change Tab:", value);
    showWorkflowStep();
    //set Prev Phases - complete
    // if (currentPhase > 0 && parseInt(value) < currentPhase) {
    //   setActiveStep(3);
    // }
    //eslint-disable-next-line
  }, [value]);

  useEffect(() => {
    if (gServiceAreas) {
      const tSA = gServiceAreas.sort((a, b) => {
        if (a.Name && b?.Name) {
          return a.Name > b.Name ? 1 : -1;
        }
        // Handle cases where either a.Name or b.Name is undefined
        if (!a.Name && b?.Name) {
          return -1;
        } else if (a.Name && !b?.Name) {
          return 1;
        }
        return 0;
      });
      setServiceAreas((areas) => tSA);
      console.log("@@GGProjectsSAs:", tSA);
    }

    //eslint-disable-next-line
  }, [gServiceAreas]);

  useEffect(() => {
    if (serviceArea) {
      fetchWorkflowStatus();
    }
    setCurrentPhase("High-Level Design");
    //eslint-disable-next-line
  }, [serviceArea]);

  useEffect(() => {
    if (workflow) {
      console.log("Workflow changed...: ", workflow);
      showWorkflowStep();
    }
    //eslint-disable-next-line
  }, [workflow]);

  const fetchProjectServiceAreas = async () => {
    if (getServiceAreasV2 && selectedProject) {
      try {
        const _serviceAreas = await getServiceAreasV2(selectedProject.ID);
        // setServiceAreas((areas) => _serviceAreas);
        // console.log("@@ProjectsSAs:", _serviceAreas);
      } catch (error) {
        console.log("@@ErrorSA:", error);
      }
    }
  };

  const fetchWorkflowStatus = async () => {
    if (serviceArea && getWorkflowStatusV2) {
      try {
        const _workflow = await getWorkflowStatusV2(serviceArea);
        setWorkflow(() => _workflow);
        // setServiceAreas((areas) => _serviceAreas);
        // console.log("@@ProjectsSAs:", _serviceAreas);
      } catch (error) {
        console.log("@@ErrorSA:", error);
      }
    }
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    console.log("Tab Value", newValue);
    setValue(newValue);
    // setTabName(pages[Number(newValue)]);
    // console.log("Tab Name", pages[Number(newValue)]);
  };
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
    null
  );

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const getNextStep = (curStatus: string) => {
    const _wfSteps = phases.find((item) => {
      if (item && item.ProcessSteps) {
        return (
          item.ProcessSteps?.findIndex((step) => step.Name === curStatus) >= 0
        );
      }
      return -1;
    });
    console.log("Workflow PHASE", _wfSteps);
    let _wfStep;
    if (_wfSteps && _wfSteps.ProcessSteps) {
      var maxStep = Math.max.apply(
        null,
        _wfSteps.ProcessSteps.map((o) => (o.StepOrder ? o.StepOrder : 0))
      );
      _wfStep = _wfSteps.ProcessSteps.find((item) => item.Name === curStatus);
      console.log("Workflow PHASE Step", _wfStep, "MAX STEP", maxStep);
      if (_wfStep && _wfStep.StepOrder === maxStep) {
        //find next phase
        // const _nextPhase = phases.find((item) => {
        //   if (item && item.ProcessSteps) {
        //     return (
        //       item.PhaseOrder ===
        //       (_wfSteps.PhaseOrder ? _wfSteps.PhaseOrder : 0) + 1
        //     );
        //   }
        //   return -1;
        // });
        // console.log("Workflow Next PHASE", _nextPhase);
        // if (_nextPhase && _nextPhase.ProcessSteps) {
        //   //find the 1st step
        //   const _step = _nextPhase.ProcessSteps.filter(
        //     (o) => o.StepOrder === 1
        //   );
        //   console.log("Workflow Next PHASE Step2", _step);
        //   return _step[0].Name;
        // } else {
        //   // No further step
        //   return curStatus;
        // }
        return _wfStep.Name;
      } else {
        //next step
        const _nextStep = _wfSteps.ProcessSteps.find(
          (item) => item.StepOrder === _wfStep.StepOrder + 1
        );
        console.log("Workflow Next PHASE Step", _nextStep);
        return _nextStep?.Name;
      }
    }
  };

  const getStepNumberForPhase = (curStep: string, curStatus: string) => {
    const _wfSteps = phases.find((item) => {
      if (item && item.ProcessSteps) {
        return (
          item.ProcessSteps?.findIndex((step) => step.Name === curStep) >= 0
        );
      }
      return -1;
    });
    console.log("Workflow PHASE", _wfSteps);
    let _wfStep;
    if (_wfSteps && _wfSteps.ProcessSteps) {
      var maxStep = Math.max.apply(
        null,
        _wfSteps.ProcessSteps.map((o) => (o.StepOrder ? o.StepOrder : 0))
      );
      _wfStep = _wfSteps.ProcessSteps.find((item) => item.Name === curStep);
      console.log("Workflow PHASE Step", _wfStep, "MAX STEP", maxStep);
      if (
        _wfStep &&
        _wfStep.StepOrder === maxStep &&
        curStatus === "Completed"
      ) {
        //find next phase
        return _wfStep.StepOrder + 1;
      } else {
        return _wfStep.StepOrder;
      }
    }
  };

  const submitAction = () => {
    console.log("Confirmation....");
    setProcessAction("UPDATE_SERVICE_AREA");
    // updateSAStatus();
    // updateWorkflowStatus();
    // clearWorkflowUpdateStatus();
    // if (updateWorkflowStatusV2) {
    //   const result = await updateWorkflowStatusV2(_updWorkflow, action);
    //   fetchWorkflowStatus();
    //   return result;
    // }

    //   if (updateServiceAreaStatusV2)
    //     return updateServiceAreaStatusV2(_updServiceArea);
    // }
  };

  const updateSAStatus = async () => {
    if (updateServiceAreaStatusV2 && currentServiceArea) {
      try {
        await updateServiceAreaStatusV2(currentServiceArea);
      } catch (error) {
        console.log("Unexpected Error while updating SA", error);
        clearWorkflowUpdateStatus();
      }
    }
  };

  const updateWorkflowStatus = async () => {
    console.log("UPDTAE workflow status", updatedWorkflow);
    console.log("UPDTAE workflow status", updatedAction);
    if (updateWorkflowStatusV2 && updatedAction) {
      try {
        await updateWorkflowStatusV2(updatedWorkflow, updatedAction);
        fetchWorkflowStatus();
      } catch (error) {
        console.log("Unexpected Error while updating WF", error);
        clearWorkflowUpdateStatus();
      }
    }
  };

  const handleUpdateStatus = async (status: string) => {
    const _currServiceArea = serviceAreas.find(
      (item) => item.ID === serviceArea
    );
    const _status = getNextStep(status);
    console.log("Current Step Status", _status);
    let action: "ADD" | "UPDATE" = "ADD";
    let _updWorkflow: Workflow = {};
    let _curStep;
    let _phase;
    if (workflow) {
      _phase = phases.filter(
        (phase) => phase.PhaseOrder === parseInt(value) + 1
      )[0];
      _curStep = workflow.filter((item) => item.Phase === _phase.Name)[0];
      if (_curStep && _curStep.OBJECTID) {
        console.log("Current Step OBJECTID", _curStep.OBJECTID);
        _updWorkflow.OBJECTID = _curStep?.OBJECTID;
        action = "UPDATE";
      }

      // workflow.filter(item=>)
      console.log("Current Phase:", _phase.Name);
      console.log("Current Step:", _curStep);
      setCurrentPhase(_phase.Name);
    }
    _updWorkflow.SA_ID = _currServiceArea?.ID;
    _updWorkflow.Phase = currentPhase;
    _updWorkflow.Step = _status;
    console.log("###_status", _status);
    console.log("###status", status);
    _updWorkflow.Status = _status === status ? "Completed" : "In-Progress";
    setUpdatedWorkflow(() => _updWorkflow);
    setUpdatedAction(() => action);
    if (_currServiceArea) {
      _currServiceArea.Status = status;
      setCurrentServiceArea(() => _currServiceArea);
    }
    console.log("###_phase", _phase.Name);
    console.log("###_updated workflow", _updWorkflow);
    console.log("###_updated action", action);
    console.log("###_updated SA", _currServiceArea);
    console.log(
      "###SA Sttus check",
      _phase.Name === "Construction" && status === "Approved for Construction"
    );

    if (
      _phase.Name === "Construction" &&
      status === "Approved for Construction"
    ) {
      console.log("###_update SA");
      showConfirmation &&
        showConfirmation(
          "Once Approved for Consruction, Design can not be changed. Please confirm",
          "confirm",
          submitAction
        );
      return;
    } else {
      setProcessAction("UPDATE_WORKFLOW");
      // updateWorkflowStatus();
    }
    // setActiveStep((item) => item + 1);

    // if (updateWorkflowStatusV2) {
    //   const result = await updateWorkflowStatusV2(_updWorkflow, action);
    //   fetchWorkflowStatus();
    //   return result;
    // }

    //   if (updateServiceAreaStatusV2)
    //     return updateServiceAreaStatusV2(_updServiceArea);
    // }

    return null;
  };

  const clearWorkflowUpdateStatus = () => {
    setUpdatedWorkflow(() => undefined);
    setUpdatedAction(() => undefined);
    setCurrentServiceArea(() => undefined);
    setProcessAction(undefined);
    clearAlert && clearAlert();
  };

  useEffect(() => {
    if (processAction && processAction === "UPDATE_WORKFLOW") {
      console.log("PROCESS workflow status", updatedWorkflow);
      console.log("PROCESS workflow action", updatedAction);
      console.log("PROCESS workflow SA", currentServiceArea);
      updateWorkflowStatus();
      clearWorkflowUpdateStatus();
    } else if (processAction && processAction === "UPDATE_SERVICE_AREA") {
      updateSAStatus();
      updateWorkflowStatus();
      clearWorkflowUpdateStatus();
    }
    //eslint-disable-next-line
  }, [processAction]);

  function handleChange(event: SelectChangeEvent) {
    setServiceArea(event.target.value as string);
    // console.log("@@ProjectsSAs:", serviceAreas);
  }

  // function handleChange(serviceArea: string) {
  //   console.log("@@ProjectsSAs:", serviceArea);
  //   if (serviceArea) setServiceArea(serviceArea);
  //   // console.log("@@ProjectsSAs:", serviceAreas);
  // }

  return (
    <div className='container contA'>
      <Grid container sx={{ width: "100%", height: "100%" }}>
        <Box
          width='100%'
          display='flex'
          justifyContent='flex-start'
          alignContent='flex-start'
        >
          <Box sx={{ display: { xs: "flex", md: "none" } }}>
            <IconButton
              size='large'
              aria-label='account of current user'
              aria-controls='menu-appbar'
              aria-haspopup='true'
              onClick={handleOpenNavMenu}
              color='inherit'
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id='menu-appbar'
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {pages.map((page) => (
                <MenuItem key={page} onClick={handleCloseNavMenu}>
                  <Typography textAlign='center'>{page}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <FormControl sx={{ m: 2, minWidth: 150 }}>
            <InputLabel id='service-area-label'>Service Areas</InputLabel>
            <Select
              id='service-area-select'
              value={serviceArea}
              onChange={handleChange}
              label='Service Areas select'
            >
              {serviceAreas &&
                serviceAreas.map((ele, index) => (
                  <MenuItem key={ele.Name} value={ele.ID}>
                    {ele.Name}
                  </MenuItem>
                ))}
            </Select>
          </FormControl>

          {/* <Box alignContent="center" sx={{ m: 0, p: 0 }}> */}
          {/* <button
            type="button"
            className="btn btn-warning"
            style={{ marginTop: 6, marginRight: 6 }}
          >
            +Add More Areas
          </button> */}
          {/* </Box> */}
        </Box>

        <Box
          sx={{
            width: "100%",
            typography: "body1",
            minHeight: "55vh",
          }}
        >
          <TabContext value={value}>
            <Box
              sx={{
                borderBottom: 1,
                borderColor: "divider",
              }}
            >
              <TabList
                onChange={handleTabChange}
                aria-label='Phases'
                value={value}
                sx={{
                  display: { xs: "none", md: "flex" },
                  // backgroundColor: "lightgrey",
                }}
              >
                {WorkflowPhases.map((ele, index) => (
                  <Tab
                    label={ele.Name}
                    value={index.toString()}
                    key={ele.PhaseOrder}
                  />
                ))}
              </TabList>
              {serviceArea &&
                WorkflowPhases.map((ele, index) => (
                  <TabPanel
                    key={ele.PhaseOrder}
                    value={index.toString()}
                    sx={{ width: "100%", p: 0, m: 0 }}
                  >
                    <ProcessStepper
                      phase={ele}
                      step={activeStep}
                      updateCallback={handleUpdateStatus}
                      key={ele.PhaseOrder}
                      projectId={selectedProject?.ID}
                    />
                  </TabPanel>
                ))}
            </Box>
          </TabContext>
        </Box>
      </Grid>
    </div>
  );
}

export default ServiceAreas;
